import { useEffect, useMemo } from 'react';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service/translations/name-space.types';
import { useLocale } from '@gov-nx/core/service/translations/useLocale';

export function useTitle(title: string | null = null) {
	const { t } = useLocale(LocalizeNameSpaceTypes.Global);

	const memoizedTitle = useMemo(() => {
		const website = t('title');
		return title ? title + ' - ' + website : website;
	}, [t, title]);

	useEffect(() => {
		const prevTitle = document.title;
		document.title = memoizedTitle;

		return () => {
			document.title = prevTitle;
		};
	}, [memoizedTitle]);
}
